  (() => {
  const inlineMenu = document.querySelector(".header__inline-menu");
  if (!inlineMenu) return;

  const OPEN_DELAY_MS = 300;   // ← tweak this (150–350ms feels good)
  const CLOSE_DELAY_MS = 0;    // close immediately; set to 80–120 if you want a soft close

  const detailsItems = inlineMenu.querySelectorAll("details");

  detailsItems.forEach((item) => {
    let openTimer = null;
    let closeTimer = null;

    const summary = item.querySelector("summary");
    const submenu = item.querySelector("ul, .mega-menu__content"); // works for either structure

    const open = () => {
      clearTimeout(closeTimer);
      if (!item.open) item.setAttribute("open", true);
    };

    const close = () => {
      clearTimeout(openTimer);
      if (item.open) item.removeAttribute("open");
    };

    // HOVER: delay open on intent
    item.addEventListener("mouseenter", () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, OPEN_DELAY_MS);
    });

    // HOVER: close quickly when leaving the whole <details>
    item.addEventListener("mouseleave", () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY_MS);
    });

    // Optional: keep open while moving inside the submenu (covers gaps)
    if (submenu) {
      submenu.addEventListener("mouseenter", () => {
        clearTimeout(closeTimer);
      });
      submenu.addEventListener("mouseleave", () => {
        closeTimer = setTimeout(close, CLOSE_DELAY_MS);
      });
    }

    // ACCESSIBILITY: open on keyboard focus, close when focus leaves the details entirely
    item.addEventListener("focusin", () => {
      clearTimeout(openTimer);
      open(); // keyboard users shouldn't wait
    });
    item.addEventListener("focusout", (e) => {
      if (!item.contains(e.relatedTarget)) close();
    });

    // Optional: close on Escape when focused inside the menu
    item.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        close();
        summary?.focus();
      }
    });

    // If you want summary click to navigate, leave as-is.
    // If you want summary click to ONLY toggle (no navigation),
    // uncomment the preventDefault below:
    // summary?.addEventListener("click", (e) => e.preventDefault());
  });
})();
